import React, { PropTypes } from 'react';
import AnswerRow from './AnswerRow';

const QuestionRow = ({ question, ...others }) => {
  return (
    <div className="tr">
      <div className="td question">{question.title}</div>
      <div className="td contain ui form">
        {question.answers.map(answer => (
          <AnswerRow key={answer.id} answer={answer} {...others} />
        ))}
      </div>
    </div>
  );
};

QuestionRow.propTypes = {
  question: PropTypes.object.isRequired,
};

export default QuestionRow;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/scoring/QuestionRow.js